import { defineMessages } from 'react-intl';

export default defineMessages({
  actionsHeader: {
    description: 'Automation Rules editor Actions header',
    defaultMessage: 'apply the following actions',
    id: 'nC+YOx',
  },
  thenBadge: {
    description: 'Badge label for the THEN actions section in the automation rule editor',
    defaultMessage: 'Then',
    id: '7WCnuR',
  },
});
